<template>
	<b-container>
		<b-form>
			<b-row class="mt-3">
				<b-col>
					<b-link class="float-right ml-3 btn btn-link" @click.prevent="deleteUser" title="Delete this user">
						<b-icon font-scale="1.5" icon="trash" variant="danger"></b-icon>
					</b-link>

					<b-link class="float-right ml-3 btn btn-link" type="submit" title="Save section" @click.prevent="updateUser">
						<b-icon font-scale="1.5" icon="check-square" variant="success"></b-icon>
					</b-link>
				</b-col>
			</b-row>

			<b-row class="mt-3">
				<b-col>
					<h1>{{ user.FullName }}</h1>
				</b-col>

				<b-form-group :label-cols="3" breakpoint="md" horizontal label="Role" for="role">
					<b-col>
						<b-form-select id="role" v-model="user.Role" :options="roles"></b-form-select>
					</b-col>
				</b-form-group>
			</b-row>

			<b-row class="mt-3">
				<b-col>
					<b-form-group :label-cols="3" breakpoint="md" horizontal label="First name" for="firstname">
						<b-input id="firstname" v-model="user.FirstName" type="text" required />
					</b-form-group>

					<b-form-group :label-cols="3" breakpoint="md" horizontal label="Last name" for="lastname">
						<b-input id="lastname" v-model="user.LastName" type="text" required />
					</b-form-group>

					<b-form-group :label-cols="3" breakpoint="md" horizontal label="Phone number" for="phonenumber">
						<b-input id="phonenumber" v-model="user.PhoneNumber" type="text" />
					</b-form-group>

					<b-form-group :label-cols="3" breakpoint="md" horizontal label="Email" for="email">
						<b-input id="email" v-model="user.Email" type="text" />
					</b-form-group>

					<b-form-group :label-cols="3" breakpoint="md" horizontal label="Address 1" for="address1">
						<b-input id="address1" v-model="user.Address.Address1" type="text" required />
					</b-form-group>

					<b-form-group :label-cols="3" breakpoint="md" horizontal label="Address 2" for="address2">
						<b-input id="address2" v-model="user.Address.Address2" type="text" />
					</b-form-group>

					<b-form-group :label-cols="3" breakpoint="md" horizontal label="Town" for="town">
						<b-input id="town" v-model="user.Address.Town" type="text" required />
					</b-form-group>

					<b-form-group :label-cols="3" breakpoint="md" horizontal label="Postcode" for="postcode">
						<b-input id="postcode" v-model="user.Address.Postcode" type="text" required />
					</b-form-group>

					<b-row class="mt-3">
						<b-col>
							<b-form-group breakpoint="md" horizontal for="latitude" label="Latitude">
								<b-form-input id="latitude" placeholder="Latitude" v-model="user.Address.Latitude" type="text" required />
							</b-form-group>
						</b-col>

						<b-col>
							<b-form-group breakpoint="md" horizontal for="longitude" label="Longitude">
								<b-form-input id="longitude" placeholder="Longitude" v-model="user.Address.Longitude" type="text" required />
							</b-form-group>
						</b-col>
					</b-row>

					<b-row class="mt-3">
						<b-col cols="11" v-if="editPassword">
							
							<b-row>
								<b-col>
									<b-input-group class="mb-3">
										<b-input-group-prepend is-text>
											<b-icon icon="file-lock-fill"></b-icon>
										</b-input-group-prepend>

										<b-form-input id="password" placeholder="New Password" class="password" v-model="reset.NewPassword"></b-form-input>
										<validatorian field="NewPassword" :response="web_api_response" />
									</b-input-group>
								</b-col>
								
								<b-col>
									<b-link class="ml-1 btn btn-link" @click.prevent="generatePassword" title="Regenerate password">
										<b-icon font-scale="1.5" icon="arrow-counterclockwise"></b-icon>
									</b-link>
		
		
									<b-link class="ml-1 btn btn-link" @click.prevent="copyToClipboard" title="Copy to clipboard">
										<b-icon font-scale="1.5" icon="clipboard"></b-icon>
									</b-link>
								</b-col>
							</b-row>

							<b-row>		
								
								<b-col>
									<span v-if="copied">Password copied successfuly!</span>
			
									<input required id="confirmpassword" type="hidden" placeholder="Confirm password" v-model="reset.ConfirmPassword" />
									
								</b-col>
								
		
							</b-row>

			
						</b-col>

						<b-col cols="5" v-else>
							<p>Reset password</p>
						</b-col>

						<b-col cols="1">
							<save-or-edit-buttons :editable="editPassword" section="editPassword" @save="resetPassword" @edit="editSection" />
						</b-col>

					</b-row>
				</b-col>

				<b-col cols="6">
					<div id="map" class="shortmap"></div>
				</b-col>
			</b-row>

			<b-row class="mt-3">
				<b-col cols="12">
					<b-card-group deck class="mb-3">
						<b-card bg-variant="light" title="Signature image">
							<image-asset :asset="user.SignatureImage" :relate="user.Id" type="1" folder="ApplicationUser" direction="up" />
						</b-card>

						<b-card bg-variant="light" title="Signature block">
							<b-form-textarea v-model="user.SignatureBlock" placeholder="Enter signature block..." rows="5" max-rows="20"></b-form-textarea>
						</b-card>
					</b-card-group>
				</b-col>
			</b-row>
		</b-form>

		<confirm ref="confirm"></confirm>
	</b-container>
</template>

<script>
import AccountService from '@/api-services/account.service';
import SaveOrEditButtons from '@/components/partials/save-or-edit-buttons';
import ImageAsset from '@/components/partials/image-asset';
import Confirm from '@/components/partials/confirm';
import Validatorian from '@/components/partials/validatorian';

import L from 'leaflet';
import 'leaflet/dist/leaflet.css';

import 'leaflet-control-geocoder';
import 'leaflet-control-geocoder/dist/Control.Geocoder.css';
import { BIconBoxArrowInDownLeft } from 'bootstrap-vue';

export default {
	name: 'UserUpdate',

	components: {
		SaveOrEditButtons,
		ImageAsset,
		Confirm,
		Validatorian
	},

	data() {
		return {
			user: {
				Address: {
					Latitude: '',
					Longitude: '',
				},
				Role: null
			},

			reset: {
				Code: '',
				Email: '',
				NewPassword: '',
				ConfirmPassword: ''
			},

			editPassword: false,

			message: null,
			web_api_response: [],

			roles: [
				{ value: null, text: 'Please select an option' },
				{ value: 'super', text: 'Super User' },
				{ value: 'admin', text: 'Administrator' },
				{ value: 'serf', text: 'User' },
				{ value: 'slave', text: 'Restricted User' }
			],

			map: null,
			tileLayer: null,
			marker: null,

			copied: false,
			settings: {
				maxLength: 64,
				maxDigits: 10,
				maxSymbols: 10,
				length: 12,
				digits: 4,
				symbols: 2,
				ambiguous: true,
			}

		};
	},

	computed: {
		
		lengthThumbPosition: function () {
			return (((this.settings.length - 6) / (this.settings.maxLength - 6)) * 100);
		},

		digitsThumbPosition: function () {
			return (((this.settings.digits - 0) / (this.settings.maxDigits - 0)) * 100);
		},

		symbolsThumbPosition: function () {
			return (((this.settings.symbols - 0) / (this.settings.maxSymbols - 0)) * 100);
		},

		strength: function () {
			var count = {
				excess: 0,
				upperCase: 0,
				numbers: 0,
				symbols: 0
			};


			var weight = {
				excess: 3,
				upperCase: 4,
				numbers: 5,
				symbols: 5,
				combo: 0,
				flatLower: 0,
				flatNumber: 0
			};

			var strength = {
				text: '',
				score: 0
			};


			var baseScore = 30;

			for (i = 0; i < this.reset.NewPassword.length; i++) {
				if (this.reset.NewPassword.charAt(i).match(/[A-Z]/g)) { count.upperCase++; }
				if (this.reset.NewPassword.charAt(i).match(/[0-9]/g)) { count.numbers++; }
				if (this.reset.NewPassword.charAt(i).match(/(.*[!,@,#,$,%,^,&,*,?,_,~])/)) { count.symbols++; }
			}

			count.excess = this.reset.NewPassword.length - 6;

			if (count.upperCase && count.numbers && count.symbols) {
				weight.combo = 25;
			}
			else if ((count.upperCase && count.numbers) || (count.upperCase && count.symbols) || (count.numbers && count.symbols)) {
				weight.combo = 15;
			}

			if (this.reset.NewPassword.match(/^[\sa-z]+$/)) {
				weight.flatLower = -30;
			}

			if (this.reset.NewPassword.match(/^[\s0-9]+$/)) {
				weight.flatNumber = -50;
			}

			var score =
				baseScore +
				(count.excess * weight.excess) +
				(count.upperCase * weight.upperCase) +
				(count.numbers * weight.numbers) +
				(count.symbols * weight.symbols) +
				weight.combo + weight.flatLower +
				weight.flatNumber;

			if (score < 30) {
				strength.text = "weak";
				strength.score = 10;
				return strength;
			} else if (score >= 30 && score < 75) {
				strength.text = "average";
				strength.score = 40;
				return strength;
			} else if (score >= 75 && score < 150) {
				strength.text = "strong";
				strength.score = 75;
				return strength;
			} else {
				strength.text = "secure";
				strength.score = 100;
				return strength;
			}
		},

	},

	created() {
		this.fetchUser();
	},


	watch: {
		settings: {
			handler: function () {
				this.generatePassword();
			},
			deep: true
		}
	},


	methods: {
		fallback(str, alt) {
			return str ? str : alt;
		},

		fetchUser() {
			AccountService.get(this.$router.currentRoute.params.id).then((response) => {
				this.user = response.data;
				if (this.user.Address == null) {
					this.user.Address = {
						Latitude: '',
						Longitude: '',
					};
					this.user.Address.Empty = true;


				} else if (
					this.user.Address.Latitude == '' &&
					this.user.Address.Longitude == null
				) {
					// so we can set the map properly
					this.user.Address.Empty = true;
				}

				this.initMap();
				this.initLayers();
			});
		},

		fetchRoles() {
			AccountService.getRoles().then((response) => {
				this.roles = response.data;
			});
		},

		updateUser() {
			// don't send null to address Id, it needs to creat a new one.
			if (this.user.AddressId == null) delete this.user.AddressId;

			AccountService.update(this.$router.currentRoute.params.id, this.user)
				.then(() => {
					this.$refs.confirm.open('Success', 'Successfully updated user', true).then((confirm) => {
						this.$router.push({ name: 'users' });
					});
				})
				.catch((error) => {
					let modal_options = {
						text: 'light',
						background: 'danger'
					};
					this.$refs.confirm.open('Error', error.response.data, true, modal_options);
				});
		},

		deleteUser() {
			this.$refs.confirm.open('Delete', 'Are you sure you want to delete this user?').then((confirm) => {
				if (confirm) {
					AccountService.delete(this.user.Id)
						.then(() => {
							this.$refs.confirm.open('Success', 'Successfully deleted user', true).then((confirm) => {
								this.$router.push({ name: 'users' });
							});
						})
						.catch((error) => {
							this.$refs.confirm.open('Error', error.response.data, true);
						});
				}
			});
		},

		resetPassword() {
			this.validation_errors = [];
			this.reset.Email = this.user.Email;
			this.reset.Code = this.user.Code;
			
			this.reset.ConfirmPassword = this.reset.NewPassword;

			AccountService.resetPassword(this.reset)
				.then((res) => {
					this.$refs.confirm.open('Success', 'Successfully updated password', true);
				})
				.catch((error) => {
					this.web_api_response = error.response.data;
					if (!this.web_api_response.ModelState) {
						this.message = error;
					}
				});
		},


		// copy password to clipboard
		copyToClipboard() {
			// we should create a textarea, put the password inside it, select it and finally copy it
			var copyElement = document.createElement("textarea");
			copyElement.style.opacity = '0';
			copyElement.style.position = 'fixed';
			copyElement.textContent = this.reset.NewPassword;
			var body = document.getElementsByTagName('body')[0];
			body.appendChild(copyElement);
			copyElement.select();
			document.execCommand('copy');
			body.removeChild(copyElement);

			this.copied = true;
			// reset this.copied
			setTimeout(() => {
				this.copied = false;
			}, 750);
		},

		// generate the password
		generatePassword() {
			var lettersSetArray = ["a", "b", "c", "d", "e", "f", "g", "h", "i", "j", "k", "l", "m", "n", "o", "p", "q", "r", "s", "t", "u", "v", "w", "x", "y", "z"];
			var symbolsSetArray = ["=", "+", "-", "^", "?", "!", "%", "&", "*", "$", "#", "^", "@", "|"];
			//var ambiguousSetArray = ["(",")","{","}","[","]","(",")","/","~",";",":",".","<",">"];
			var passwordArray = [];
			var digitsArray = [];
			var digitsPositionArray = [];


			// first, fill the password array with letters, uppercase and lowecase
			for (var i = 0; i < this.settings.length; i++) {
				// get an array for all indexes of the password array
				digitsPositionArray.push(i);

				var upperCase = Math.round(Math.random() * 1);
				if (upperCase === 0) {
					passwordArray[i] = lettersSetArray[Math.floor(Math.random() * lettersSetArray.length)].toUpperCase();
				}
				else {
					passwordArray[i] = lettersSetArray[Math.floor(Math.random() * lettersSetArray.length)];
				}
			}

			// Add digits to password
			for (i = 0; i < this.settings.digits; i++) {
				let digit = Math.round(Math.random() * 9);
				let numberIndex = digitsPositionArray[Math.floor(Math.random() * digitsPositionArray.length)];

				passwordArray[numberIndex] = digit;

				/* remove position from digitsPositionArray so we make sure to the have the exact number of digits in our password
				since without this step, numbers may override other numbers */

				var j = digitsPositionArray.indexOf(numberIndex);
				if (i != -1) {
					digitsPositionArray.splice(j, 1);
				}
			}

			// add special charachters "symbols"
			for (i = 0; i < this.settings.symbols; i++) {
				var symbol = symbolsSetArray[Math.floor(Math.random() * symbolsSetArray.length)];
				var symbolIndex = digitsPositionArray[Math.floor(Math.random() * digitsPositionArray.length)];

				passwordArray[symbolIndex] = symbol;

				/* remove position from digitsPositionArray so we make sure to the have the exact number of digits in our password
				since without this step, numbers may override other numbers */

				var j = digitsPositionArray.indexOf(symbolIndex);
				if (i != -1) {
					digitsPositionArray.splice(j, 1);
				}
			}
			this.reset.NewPassword = passwordArray.join("");
			this.reset.ConfirmPassword = this.reset.NewPassword;

		},

		initMap() {
			if (this.hasLtLng()) {
				this.map = L.map('map').setView([this.user.Address.Latitude, this.user.Address.Longitude], 10);
			} else {
				this.map = L.map('map').setView([54.4, -2.8], 7);
			}

			this.tileLayer = L.tileLayer('https://{s}.tile.osm.org/{z}/{x}/{y}.png', {
				maxZoom: 18,
				attribution: '&copy; <a href="https://osm.org/copyright">OpenStreetMap</a> contributors'
			});

			this.tileLayer.addTo(this.map);

			// to avoid scope conflict with this
			var vm = this;

			this.map.on('click', function (e) {
				if (confirm('Set Map location?')) {

					vm.user.Address.Latitude = e.latlng.lat.toFixed(6);
					vm.user.Address.Longitude = e.latlng.lng.toFixed(6);
					vm.user.Address.Empty = false;

					if (vm.marker) {
						vm.marker.remove();
					}

					vm.initLayers();
				}
			});
		},

		initLayers() {
	
			if (this.hasLtLng()) {

				this.marker = L.marker([this.user.Address.Latitude, this.user.Address.Longitude]);

				this.marker.addTo(this.map);
			}
		},

		editSection(section) {
			this[section] = true;

			//this.generatePassword();
		},

		hasLtLng() {
			let doWe = false;

			if (this.user.Address)
			{
				if (this.user.Address.Latitude && this.user.Address.Longitude)
				{
					doWe = true;
				}

			}
	
			return doWe;

		}
	}
};
</script>



// WEBPACK FOOTER //
// src/components/account/user-update.vue